import { render } from "./DropdownLink.vue?vue&type=template&id=50d4f086"
import script from "./DropdownLink.vue?vue&type=script&lang=js"
export * from "./DropdownLink.vue?vue&type=script&lang=js"
script.render = render

export default script